import { render, staticRenderFns } from "./ClinicShopComingSoon.vue?vue&type=template&id=a1917d10&"
import script from "./ClinicShopComingSoon.vue?vue&type=script&lang=js&"
export * from "./ClinicShopComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./ClinicShopComingSoon.vue?vue&type=style&index=0&id=a1917d10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports